// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessShovelSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.167 3.879a3 3 0 0 1 4.243 0l.707.707a3 3 0 0 1 0 4.242l-3.89 3.89a.5.5 0 0 1-.706 0l-1.414-1.415L4.56 20.85a.5.5 0 0 1-.707 0l-.708-.707a.5.5 0 0 1 0-.707l9.546-9.546-1.414-1.414a.5.5 0 0 1 0-.707z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessShovelSolid;
